import React from "react";
import { OPT_IN_DISCLAIMER_FIELDS } from "../../../../constants/optInDisclaimerFields";
import PrivacyDisclaimerText from "../../../Common/EventRegistration/PrivacyDisclaimerText";

const OptInDisclaimerPreview = () => (
  <div
    style={{
      background: "white",
      borderRadius: "16px",
      padding: "24px",
      marginBottom: "20px",
      boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
      border: "1px solid rgba(226, 232, 240, 0.8)",
    }}
  >
    <h6
      style={{
        fontSize: "14px",
        fontWeight: "700",
        color: "#1e293b",
        marginBottom: "20px",
        paddingBottom: "12px",
        borderBottom: "2px solid #f1f5f9",
      }}
    >
      Opt-in &amp; Privacy (automatically included at bottom)
    </h6>
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      {OPT_IN_DISCLAIMER_FIELDS.map((field) =>
        field.question_type === "privacy_disclaimer" ? (
          <PrivacyDisclaimerText key={field.name} linkUrl={field.linkUrl} />
        ) : (
          <label
            key={field.name}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              fontSize: "14px",
              color: "#475569",
              fontWeight: "500",
              margin: 0,
              cursor: "default",
            }}
          >
            <input
              type="checkbox"
              disabled
              style={{ width: "18px", height: "18px", marginTop: "2px", flexShrink: 0 }}
            />
            <span>{field.label}</span>
          </label>
        )
      )}
    </div>
  </div>
);

export default OptInDisclaimerPreview;
